<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <WorkDocsDocumentTypeTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkDocsDocumentTypeTableItem from 'components/setting/workDocsDocumentType/WorkDocsDocumentTypeTableItem'
export default {
  name: 'WorkDocsDocumentTypeTable',
  props: ['items'],
  components: { WorkDocsDocumentTypeTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-document_type']['tables']['nazvanie'],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
}
</script>
